import createAPI from '../axios'

// 选修管理相关API
const electiveManageSkillsTraining = {
    classSetting: {
        list: config => createAPI('/classSettingSkillsTraining/list', 'post', config),
        initOption: config => createAPI('/classSettingSkillsTraining/initOption', 'post', config),
        deptOption: config => createAPI('/classSettingSkillsTraining/deptOption', 'post', config),
        majorOption: config => createAPI('/classSettingSkillsTraining/majorOption', 'post', config),
        classOption: config => createAPI('/classSettingSkillsTraining/classOption', 'post', config),
        queryElectiveTime: config => createAPI('/classSettingSkillsTraining/queryElectiveTime', 'post', config),
        saveElectiveTime: config => createAPI('/classSettingSkillsTraining/saveElectiveTime', 'post', config),
        initCredit: config => createAPI('/classSettingSkillsTraining/initCredit', 'post', config),
        queryCredit: config => createAPI('/classSettingSkillsTraining/queryCredit', 'post', config),
        saveCreditSet: config => createAPI('/classSettingSkillsTraining/saveCreditSet', 'post', config),
        getWeeknum: config => createAPI('/classSettingSkillsTraining/getWeeknum', 'post', config),
        courseOption: config => createAPI('/classSettingSkillsTraining/courseOption', 'post', config),
        classTimeOption: config => createAPI('/classSettingSkillsTraining/classTimeOption', 'post', config),
        queryTeacher: config => createAPI('/classSettingSkillsTraining/queryTeacher', 'post', config),
        querySite: config => createAPI('/classSettingSkillsTraining/querySite', 'post', config),
        saveElective: config => createAPI('/classSettingSkillsTraining/saveElective', 'post', config),
        delElective: config => createAPI('/classSettingSkillsTraining/delElective', 'post', config),
        timeslotOption: config => createAPI('/classSettingSkillsTraining/timeslotOption', 'post', config),
        relatedCourseOption: config => createAPI('/classSettingSkillsTraining/relatedCourseOption', 'post', config),
        courseTypeOption: config => createAPI('/classSettingSkillsTraining/courseTypeOption', 'post', config),
    },
    studentSelection: {
        list: config => createAPI('/studentSelectionSkillsTraining/list', 'post', config),
        initOption: config => createAPI('/studentSelectionSkillsTraining/initOption', 'post', config),
        checkSelectTime: config => createAPI('/studentSelectionSkillsTraining/checkSelectTime', 'post', config),
        studentSelectionAdultEducation: config => createAPI('/studentSelectionSkillsTraining/studentSelectionSkillsTraining', 'post', config),
        queryStuSelection: config => createAPI('/studentSelectionSkillsTraining/queryStuSelection', 'post', config),
        delSelection: config => createAPI('/studentSelectionSkillsTraining/delSelection', 'post', config),
    },
    electiveManage: {
        list: config => createAPI('/electiveManageSkillsTraining/list', 'post', config),
        initOption: config => createAPI('/electiveManageSkillsTraining/initOption', 'post', config),
        queryElectiveClassStu: config => createAPI('/electiveManageSkillsTraining/queryElectiveClassStu', 'post', config),
        queryStudent: config => createAPI('/electiveManageSkillsTraining/queryStudent', 'post', config),
        saveElectiveStu: config => createAPI('/electiveManageSkillsTraining/saveElectiveStu', 'post', config),
        queryChangeClassList: config => createAPI('/electiveManageSkillsTraining/queryChangeClassList', 'post', config),
        changeElectiveStu: config => createAPI('/electiveManageSkillsTraining/changeElectiveStu', 'post', config),
        delElectiveStu: config => createAPI('/electiveManageSkillsTraining/delElectiveStu', 'post', config),
        exportCourse: config => createAPI('/electiveManageSkillsTraining/exportCourse', 'post', config),
        exportStudent: config => createAPI('/electiveManageSkillsTraining/exportStudent', 'post', config),
        queryInsufficientCredit: config => createAPI('/electiveManageSkillsTraining/queryInsufficientCredit', 'post', config),
        queryStuCredit: config => createAPI('/electiveManageSkillsTraining/queryStuCredit', 'post', config),
        exportCredit: config => createAPI('/electiveManageSkillsTraining/exportCredit', 'post', config),
        importElectiveScore: config => createAPI('/electiveManageSkillsTraining/importElectiveScore', 'post', config),
        queryNoChooseXXK: config => createAPI('/electiveManageSkillsTraining/queryNoChooseXXK', 'post', config),
        exportNochoose: config => createAPI('/electiveManageSkillsTraining/exportNochoose', 'post', config),
    },
    electiveInfo: {
        list: config => createAPI('/electiveInfoSkillsTraining/list', 'post', config),
        initOption: config => createAPI('/electiveInfoSkillsTraining/initOption', 'post', config),
        deptOption: config => createAPI('/electiveInfoSkillsTraining/deptOption', 'post', config),
        majorOption: config => createAPI('/electiveInfoSkillsTraining/majorOption', 'post', config),
        classOption: config => createAPI('/electiveInfoSkillsTraining/classOption', 'post', config),
        exportStuSelection: config => createAPI('/electiveInfoSkillsTraining/exportStuSelection', 'post', config),
    }
};

export default electiveManageSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/electiveManageSkillsTraining.js